import Hero from "@/components/Hero";
import PlatformCapabilities from "@/components/PlatformCapabilities";
import StatsSection from "@/components/StatsSection";
import CTASection from "@/components/CTASection";

export default function Home() {
  return (
    <div
      className="min-h-screen"
      style={{
        backgroundImage: "url('/assets/shared/simple-bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <main className="pt-4 px-3 sm:px-4 lg:px-6 pb-12">
        <Hero />
        <PlatformCapabilities />
        <StatsSection />
        <CTASection />
      </main>
    </div>
  );
}
